module.exports = __webpack_public_path__ + "site/img/4.a88a6748.jpg";